import React, { useEffect, useState } from 'react'
import '../../ApplicationsDashboard/ApplicationsDashboard.css';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../components/Sidebar/Sidebar';
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSearch,
    faBell,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
import './RepaymentReports.css'
import { useDispatch, useSelector } from 'react-redux';
import { getRepaymentReport } from '../../../redux/ReportsReducer/action';
import DatePicker from 'react-datepicker';
import DownloadReport from '../DownloadReport';
import { downloadReport, resetFilters } from '../../../utils/reportUtils';
import FunnelIconSvg from '../../../components/SVG/FunnelIconSvg';
import FilterModal from '../FilterModal/FilterModal';
import { REPORTS_COMPONENTS } from '../../../config/reports';
import { isAuthorised } from '../../../utils/common';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import { getAuthToken } from "../../../utils/auth";

const RepaymentReports = () => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    const { repaymentReport, pagination, officerProfile } = useSelector((store) => {
        return {
            repaymentReport: store.ReportsReducer.repaymentReport.data,
            pagination: store.ReportsReducer.repaymentReport.pagination,
            officerProfile: store.UserReducer.officerProfile
        }
    }, []);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const leads = [];

    const storedFilters = JSON.parse(sessionStorage.getItem('rpsFilters')) || {};

    const [rpsFilters, setRPSFilters] = useState({
        branch_name: storedFilters?.branch_name || "",
        customer_name: storedFilters?.customer_name || "",
        customer_id: storedFilters?.customer_id || "",
        loan_id: storedFilters?.loan_id || "",
        ro_name: storedFilters?.ro_name || "",
        co_borrower_phone_number: storedFilters?.co_borrower_phone_number || "",
        customer_phone_number: storedFilters?.customer_phone_number || "",
        status: storedFilters?.status || "",
        loan_creation_from: storedFilters?.loan_creation_from || "",
        loan_creation_to: storedFilters?.loan_creation_to || "",
        global_search: storedFilters?.global_search || ""
    });

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('reportsCurrentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('reportsLimit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('reportsTotalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    const [dateRange, setDateRange] = useState([
        rpsFilters?.loan_creation_from ? new Date(rpsFilters.loan_creation_from) : null,
        rpsFilters?.loan_creation_to ? new Date(rpsFilters.loan_creation_to) : null,
    ]);

    const [startDate, endDate] = dateRange;

    useEffect(() => {
        dispatch(getRepaymentReport(currentPage, limit, rpsFilters, null));

        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
        sessionStorage.setItem('rpsFilters', JSON.stringify(rpsFilters));
        // }, [dispatch, limit, currentPage, rpsFilters]);
    }, [dispatch, limit, currentPage]);

    useEffect(() => {
        return () => {
            sessionStorage.removeItem("rpsFilters");
            sessionStorage.removeItem("reportsCurrentPage");
            sessionStorage.removeItem("reportsLimit");
            sessionStorage.removeItem("reportsTotalPages");
            sessionStorage.removeItem("reportsTotalCount");
        };
    }, []);

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('reportsCurrentPage', pageToSet.toString());
    };

    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleDateRangeChange = (update) => {
        setDateRange(update);

        const [start, end] = update;

        const updatedFilters = {
            ...rpsFilters,
            loan_creation_from: formatDate(start),
            loan_creation_to: formatDate(end),
        };

        setRPSFilters(updatedFilters);
        sessionStorage.setItem("rpsFilters", JSON.stringify(updatedFilters));
    };

    const handleFilterChange = (e) => {
        let { name, value } = e.target;

        if (typeof value === 'string') {
            value = value.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
        }

        let updatedFilters = {
            ...rpsFilters,
            [name]: value
        };

        setRPSFilters(updatedFilters);
        sessionStorage.setItem("rpsFilters", JSON.stringify(updatedFilters));
    }

    useEffect(() => {
        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
    }, [limit, currentPage]);

    return (
        <>
            <div className="reportsDashboardContainer">
                <div className="reportsDashboard">
                    <Sidebar />

                    <div className="dashboardMainContent">
                        <div className="contentHeader">
                            <div className="userLogo">
                                <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                            </div>
                            <div className="headerRightPanel">
                                {/* <div className="headerSearchBar">
                                <input type="text" placeholder="Search" />
                                <FontAwesomeIcon icon={faSearch} />
                            </div>
                            <div className="headerNotifications">
                                <FontAwesomeIcon icon={faBell} />
                                <span className="notificationBadge">9+</span>
                            </div>
                            <div className="headerHelp">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </div> */}
                                <UserProfileDropdown />
                            </div>
                        </div>

                        <div className="pageContentWrapper">
                            <div className="pageHeaderSection">
                                <Breadcrumb items={[
                                    { label: 'Admin' },
                                    { label: 'Reports', onClick: () => navigate('/reports') },
                                    { label: 'Repayment Reports' }
                                ]} />

                                <div className="pageActions">
                                    <h2>Repayment Reports</h2>
                                </div>
                            </div>

                            <div className="searchControlSection">
                                <div className="searchGroup">
                                    {isAuthorised(
                                        officerProfile,
                                        REPORTS_COMPONENTS['repayment_search']
                                    ) && <div className="tableSearchBar">
                                            <input
                                                // type="text" 
                                                type="search"
                                                placeholder="Search"
                                                name="global_search"
                                                value={rpsFilters?.global_search}
                                                onChange={handleFilterChange}
                                                onInput={(e) => {
                                                    if (e.target.value === "") {
                                                        let updatedFilters = {
                                                            ...rpsFilters,
                                                            global_search: e.target.value
                                                        }

                                                        setRPSFilters(updatedFilters)

                                                        dispatch(getRepaymentReport(1, limit, updatedFilters));
                                                        handlePageChange(1);
                                                    }
                                                }}
                                            />
                                            {/* <FontAwesomeIcon icon={faSearch} /> */}
                                        </div>}
                                    <div className="searchActionButtons">
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['repayment_search']
                                        ) && <button
                                            className="searchButton iconOnly"
                                            title="Search"
                                            onClick={() => {
                                                dispatch(getRepaymentReport(1, limit, rpsFilters, null));
                                            }}
                                        >
                                                <FontAwesomeIcon icon={faSearch} />
                                            </button>}
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['repayment_download']
                                        ) && <button
                                            className="downloadButton"
                                            // onClick={() => setShowDownloadModal(true)}
                                            onClick={() => {
                                                downloadReport("repayment", rpsFilters, setIsDownloading);
                                            }}
                                            disabled={isDownloading}
                                        >
                                                {isDownloading ? (
                                                    <>
                                                        <span className="buttonSpinner"></span>
                                                        Downloading...
                                                    </>
                                                ) : (
                                                    <>
                                                        Download
                                                    </>
                                                )}
                                            </button>}
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['repayment_filters']
                                        ) && (
                                                <div className="filterPopoverWrapper">
                                                    <button
                                                        className="filterButton"
                                                        onClick={() => setShowFilterModal(!showFilterModal)}
                                                    >
                                                        <FunnelIconSvg fillColor={"black"} />
                                                    </button>
                                                    {showFilterModal && (
                                                        <FilterModal
                                                            reportTitle={"repayment"}
                                                            filters={rpsFilters}
                                                            setFilters={setRPSFilters}
                                                            resetFilters={() => {
                                                                let resettedFilters = resetFilters(rpsFilters);

                                                                setRPSFilters(resettedFilters);
                                                                dispatch(getRepaymentReport(1, limit, resettedFilters, null));
                                                                setShowFilterModal(false);
                                                                sessionStorage.setItem("rpsFilters", JSON.stringify(resettedFilters));
                                                                handlePageChange(1);
                                                                return resettedFilters;
                                                            }}
                                                            handleApplyFilters={(finalFilters) => {
                                                                handlePageChange(1);
                                                                dispatch(getRepaymentReport(1, limit, finalFilters, null));
                                                                setShowFilterModal(false);
                                                            }}
                                                            onClose={() => {
                                                                setShowFilterModal(false);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>



                            <div className="tableCard">
                                <main className="">
                                    <div className="reportsTableContainer">
                                        <table className="applications-table" style={{ overflowX: "auto" }}>
                                            <thead>
                                                <tr>
                                                    <th>Branch</th>
                                                    <th>Customer Name</th>
                                                    <th>Customer ID</th>
                                                    <th>Loan ID</th>
                                                    <th>Tranche ID</th>
                                                    <th>RO - Assigned</th>
                                                    <th>Borrower Name</th>
                                                    <th>Co-Borrower Mobile Number</th>
                                                    <th>Borrower Address</th>
                                                    <th>Loan Creation Date</th>
                                                    <th>Tranche Amount</th>
                                                    <th>Tranche Count</th>
                                                    <th>Customer Mobile No.</th>
                                                    <th>RO - Assigned Contact No.</th>
                                                    <th>OD Status</th>
                                                    <th>DPD</th>
                                                    <th>Tranche O/S Total</th>
                                                    <th>Limit Available</th>
                                                    <th>Last Due Amount Total</th>
                                                    <th>Last Paid Amount Total</th>
                                                    <th>Last Due Date</th>
                                                    <th>Last Payment Date</th>
                                                    <th>Current Due Amount Total</th>
                                                    <th>Current OD Amount Total</th>
                                                    <th>Current Demand Amount</th>
                                                    <th>Next Due Amount</th>
                                                    <th>Next Due Date</th>
                                                </tr>
                                                {/* <tr className="filter-row">
                                        <td>
                                            <input
                                                type="text"
                                                name="branch_name"
                                                value={rpsFilters?.branch_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="customer_name"
                                                value={rpsFilters?.customer_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="customer_id"
                                                value={rpsFilters?.customer_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="loan_id"
                                                value={rpsFilters?.loan_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="ro_name"
                                                value={rpsFilters?.ro_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="co_borrower_phone_number"
                                                value={rpsFilters?.co_borrower_phone_number || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td>
                                            <DatePicker
                                                selectsRange
                                                startDate={startDate}
                                                endDate={endDate}
                                                onChange={handleDateRangeChange}
                                                isClearable
                                                placeholderText="Select date range"
                                                className="form-control form-control-sm date-picker-filter"
                                            />
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="customer_phone_number"
                                                value={rpsFilters?.customer_phone_number || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td>
                                            <select
                                                name="status"
                                                value={rpsFilters?.status || ""}
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            >
                                                <option value="Active">Active</option>
                                                <option value="Closed">Closed</option>
                                                <option value="OD">OD</option>
                                                <option value="No OD">No OD</option>
                                                <option value="All">All Types</option>
                                            </select>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr> */}
                                            </thead>
                                            <tbody>
                                                {
                                                    repaymentReport?.length === 0 ?
                                                        <tr>
                                                            <td colSpan={12} className="no-data-cell">
                                                                No records found
                                                            </td>
                                                        </tr> :
                                                        repaymentReport?.map((rps, index) => (
                                                            <tr key={index}>
                                                                <td>{rps?.branch_name}</td>
                                                                <td>{rps?.customer_name}</td>
                                                                <td>{rps?.customer_id}</td>
                                                                <td>{rps?.loan_id}</td>
                                                                <td>{rps?.tranche_ids?.join(", ")}</td>
                                                                <td>{rps?.ro_name}</td>
                                                                <td>{rps?.borrower_name}</td>
                                                                <td>{rps?.co_borrower_phone_number}</td>
                                                                <td>{rps?.borrower_address}</td>
                                                                <td>{rps?.loan_created_at}</td>
                                                                <td>{rps?.tranche_amount}</td>
                                                                <td>{rps?.tranche_count}</td>
                                                                <td>{rps?.customer_phone_number}</td>
                                                                <td>{rps?.ro_assigned_contact_no}</td>
                                                                <td>{rps?.od_status}</td>
                                                                <td>{rps?.dpd}</td>
                                                                <td>{rps?.tranche_os_total}</td>
                                                                <td>{rps?.limit_available}</td>
                                                                <td>{rps?.last_due_amt_total}</td>
                                                                <td>{rps?.last_paid_amt_total}</td>
                                                                <td>{rps?.last_due_date}</td>
                                                                <td>{rps?.last_payment_date?.split('T')?.[0]}</td>
                                                                <td>{rps?.current_due_amt_total}</td>
                                                                <td>{rps?.current_od_amt_total}</td>
                                                                <td>{rps?.current_demand_amt}</td>
                                                                <td>{rps?.next_due_amount}</td>
                                                                <td>{rps?.next_due_date}</td>
                                                            </tr>
                                                        ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {repaymentReport?.length > 0 && <div className="paginationControls">
                                        <CustomPagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>}
                                </main>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                showDownloadModal && (
                    <DownloadReport
                        isOpen={showDownloadModal}
                        onClose={() => setShowDownloadModal(false)}
                        reportTitle={"repayment"}
                    />
                )
            }
        </>
    )
}

export default RepaymentReports